import React from 'react';

class Clients extends React.Component {
    render() {
        return (
            <div id="clients" className="section-padding bg-gray">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title wow fadeInDown" data-wow-delay="0.3s">NOTABLE CLIENTS</h2>
                        <p>We have helped and guided organisations to achieve outstanding results</p>
                    </div>
                    <div className="row text-align-">
                        <div className="col-lg-3 col-md-3 col-xs-12 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="client-item-wrapper">
                                <img className="img-fluid" src="assets/img/clients/ezfinanz-logo.png" alt="Ezinanz Logo" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-xs-12 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="client-item-wrapper">
                                <img className="img-fluid" src="assets/img/clients/nettlinx-logo.png" alt="Nettlinx Logo" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-xs-12 wow fadeInUp" data-wow-delay="0.9s">
                            <div className="client-item-wrapper">
                                <img className="img-fluid" src="assets/img/clients/nbsl-logo.png" alt="Nebsl Logo" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-xs-12 wow fadeInUp" data-wow-delay="1.2s">
                            <div className="client-item-wrapper">
                                <img className="img-fluid" src="assets/img/clients/svgreen-logo.png" alt="Svgreen Logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/sections/Clients.js